/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PatientJourneyRecipient } from './PatientJourneyRecipient';
import {
    PatientJourneyRecipientFromJSON,
    PatientJourneyRecipientFromJSONTyped,
    PatientJourneyRecipientToJSON,
    PatientJourneyRecipientToJSONTyped,
} from './PatientJourneyRecipient';

/**
 * 
 * @export
 * @interface PatientJourneyEntry
 */
export interface PatientJourneyEntry {
    /**
     * Referral id for a sent entry, lead id for a received one.
     */
    id: string;
    /**
     * The ROC referral behind this entry. Null for a received entry that did not come in through ROC.
     */
    referral_id: string | null;
    /**
     * The sending lead for a sent entry, the received lead for a received one.
     */
    lead_id: string;
    /**
     * The facility that owns lead_id.
     */
    facility_id: string;
    /**
     * 
     */
    direction: PatientJourneyEntryDirectionEnum;
    /**
     * sent_at for a sent entry, lead_received_date for a received one.
     */
    date: Date | null;
    /**
     * Set for sent entries and for received entries that came in through ROC.
     */
    referral_type: string | null;
    /**
     * The receiving facility's type, used as the service type when referral_type is null.
     */
    facility_type: string | null;
    /**
     * 
     */
    source_name: string | null;
    /**
     * 
     */
    recipients: Array<PatientJourneyRecipient>;
    /**
     * The lead's review stage. Received entries only.
     */
    review_stage: string | null;
    /**
     * The lead's admission status. Received entries only; sent entries carry it per recipient.
     */
    admission_status: string | null;
}


/**
 * @export
 */
export const PatientJourneyEntryDirectionEnum = {
    Sent: 'sent',
    Received: 'received',
} as const;
export type PatientJourneyEntryDirectionEnum = typeof PatientJourneyEntryDirectionEnum[keyof typeof PatientJourneyEntryDirectionEnum];


/**
 * Check if a given object implements the PatientJourneyEntry interface.
 */
export function instanceOfPatientJourneyEntry(value: object): value is PatientJourneyEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('direction' in value) || value['direction'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('referral_type' in value) || value['referral_type'] === undefined) return false;
    if (!('facility_type' in value) || value['facility_type'] === undefined) return false;
    if (!('source_name' in value) || value['source_name'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    if (!('review_stage' in value) || value['review_stage'] === undefined) return false;
    if (!('admission_status' in value) || value['admission_status'] === undefined) return false;
    return true;
}

export function PatientJourneyEntryFromJSON(json: any): PatientJourneyEntry {
    return PatientJourneyEntryFromJSONTyped(json, false);
}

export function PatientJourneyEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientJourneyEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'referral_id': json['referral_id'],
        'lead_id': json['lead_id'],
        'facility_id': json['facility_id'],
        'direction': json['direction'],
        'date': (json['date'] == null ? null : parseDateTime(json['date'])),
        'referral_type': json['referral_type'],
        'facility_type': json['facility_type'],
        'source_name': json['source_name'],
        'recipients': ((json['recipients'] as Array<any>).map(PatientJourneyRecipientFromJSON)),
        'review_stage': json['review_stage'],
        'admission_status': json['admission_status'],
    };
}

export function PatientJourneyEntryToJSON(json: any): PatientJourneyEntry {
    return PatientJourneyEntryToJSONTyped(json, false);
}

export function PatientJourneyEntryToJSONTyped(value?: PatientJourneyEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'referral_id': value['referral_id'],
        'lead_id': value['lead_id'],
        'facility_id': value['facility_id'],
        'direction': value['direction'],
        'date': value['date'] == null ? value['date'] : serializeDateTime(value['date']),
        'referral_type': value['referral_type'],
        'facility_type': value['facility_type'],
        'source_name': value['source_name'],
        'recipients': ((value['recipients'] as Array<any>).map(PatientJourneyRecipientToJSON)),
        'review_stage': value['review_stage'],
        'admission_status': value['admission_status'],
    };
}

